import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/php': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320 104.5c-171.3 0-303.2 72.2-303.2 151.5s131.8 151.5 303.2 151.5c171.3 0 303.2-72.2 303.2-151.5s-131.8-151.5-303.2-151.5zM320 87.7c176.7 0 320 75.3 320 168.3s-143.3 168.3-320 168.3-320-75.3-320-168.3 143.3-168.3 320-168.3zM218.2 242.5c7.4-38.4-18.4-34.3-56.4-34.3l-13.7 70.6c34.3 0 62.2 4.2 70.1-36.3zM97.4 350.3l32.7-168.7h70.7c21.2 0 36.8 5.5 46.5 16.7 18.6 21.4 11.8 64.1-14.3 88.1-23.6 22.1-49.1 19.1-90.2 19.1l-8.7 44.8h-36.7zM283.1 136.7h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5zM505 242.5c7.4-38.4-18.2-34.3-56.4-34.3l-13.7 70.6c33.4 0 62.1 4.8 70.1-36.3zM384.2 350.3l32.8-168.7h70.7c21.2 0 36.8 5.5 46.5 16.7 18.6 21.4 11.8 64.1-14.3 88.1-23.1 21.6-47 19.1-90.2 19.1l-8.7 44.8h-36.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/php.js
// module id = 968
// module chunks = 0